import { Add, AddCircleOutline, DoNotDisturb } from "@mui/icons-material";
import {
    Box,
    Card,
    Typography,
    Stack,
    IconButton,
} from "@mui/material";
import { ElementType, useState } from "react";
import { HelperInstruction } from "./Instruction";
import { 
    HelperInstruction as InstructionData,
    HelperView} from "@my-helpers/common";

interface HelperInstructionsProps {
    currentHelper?: HelperView;
    handleChangeDefaultInstruction: (value: string) => void;
    createInstruction: (helperId: string, instruction: InstructionData) => Promise<boolean>;
    deleteInstruction: (helperId: string, instructionId: string) => Promise<boolean>;
    updateInstruction: (helperId: string, instructionId: string, instruction: InstructionData) => Promise<boolean>;
}

export const HelperInstructions: ElementType<HelperInstructionsProps> = ({ 
    currentHelper,
    handleChangeDefaultInstruction,
    createInstruction,
    deleteInstruction,
    updateInstruction
}) => {
    const [showAddForm, setShowAddForm] = useState(false);

    return (
        <Card sx={{
            flex: 1,
            maxHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            overflow: 'hidden',
            pb: 1,
        }}>
            <Box sx={{
                p: 3,
                pb: 2.3,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexShrink: 0
            }}>
                <Typography 
                    variant="h5" 
                    fontWeight="bold"
                    sx={{ color: 'primary.dark' }}>
                    Instructions
                </Typography>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                }}>
                    {
                        showAddForm ?
                            <IconButton
                                onClick={() => setShowAddForm(!showAddForm)}
                                size="small"
                                sx={{
                                    color: 'primary.main',
                                    '&:hover': {
                                        color: 'primary.dark',
                                    },
                                }}>
                                <DoNotDisturb />
                            </IconButton> :

                            <IconButton
                                disabled={!currentHelper}
                                onClick={() => setShowAddForm(!showAddForm)}
                                size="small"
                                sx={{
                                    color: 'primary.main',
                                    '&:hover': {
                                        color: 'primary.dark',
                                    },
                                }}
                            >
                                <AddCircleOutline />
                            </IconButton>
                    }
                </Box>
            </Box>

            <Box sx={{
                flexGrow: 1,
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
                px: 2
            }}>
                <Stack spacing="0.2rem">
                    {
                        currentHelper && showAddForm && 
                        <HelperInstruction
                            helperId={currentHelper.id}
                            createInstruction={createInstruction}
                            isDefaultInstruction={false}
                            deleteInstruction={deleteInstruction}
                            updateInstruction={updateInstruction}
                            handleDefaultInstructionChange={handleChangeDefaultInstruction}
                            setShowAddForm={setShowAddForm}
                        />
                    }
                    { currentHelper && currentHelper.instructions.map((instruction) => (
                        <HelperInstruction
                            key={instruction.id}
                            helperId={currentHelper.id}
                            instruction={instruction}
                            handleDefaultInstructionChange={handleChangeDefaultInstruction}
                            isDefaultInstruction={instruction.is_default}
                            deleteInstruction={deleteInstruction}
                            updateInstruction={updateInstruction}
                            createInstruction={createInstruction}
                            setShowAddForm={setShowAddForm}
                        />
                    ))}
                </Stack>
            </Box>
        </Card>
    );
}